<template>
	<li>
		<div class="value animated" :class="impact.animation" v-if="desktop">
			<div class="first">
				<img :src="imagePath" :alt="impact.value" />
			</div>
			<div class="second">
				<h2 :class="$i18n.locale" :id="this.impact.name">
					<number
						animationPaused
						ref="number1"
						:from="0"
						:to="impact.value"
						:format="theFormat"
						:duration="3"
						:delay="0"
						easing="Power1.easeOut"
					/>
					<sub v-if="impact.value.includes('kg')">kg</sub>
				</h2>
				<p class="value-description" v-html="impact.description"></p>
			</div>
		</div>

		<div
			class="value fadeInUp"
			v-if="!desktop"
			v-wow="{
				'animation-duration': '1s',
				'animation-delay': '0.3s',
			}"
		>
			<div class="first">
				<img :src="imagePath" :alt="impact.value" />
			</div>
			<div class="second">
				<h2 :class="$i18n.locale" :id="this.impact.name">
					<number
						animationPaused
						ref="number1"
						:from="0"
						:to="impact.value"
						:format="theFormat"
						:duration="3"
						:delay="0.3"
						easing="Power1.easeOut"
					/>
					<sub v-if="impact.value.includes('kg')">kg</sub>
				</h2>
				<p class="value-description" v-html="impact.description"></p>
			</div>
		</div>
	</li>
</template>

<script>
function elementInViewport(el) {
	var top = el.offsetTop
	var height = el.offsetHeight

	while (el.offsetParent) {
		el = el.offsetParent
		top += el.offsetTop
	}

	return (
		top >= window.pageYOffset &&
		top + height <= window.pageYOffset + window.innerHeight
	)
}
var numeral = require('numeral')
export default {
	name: 'ImpactItem',
	props: ['impact'],
	data() {
		return {
			desktop: true,
		}
	},
	computed: {
		imagePath() {
			return require('../../assets/img/' + this.impact.image)
		},
	},
	created() {
		if (window.innerWidth < 768) {
			this.desktop = false
		}
		document.addEventListener('scroll', this.handleScroll)
	},
	destroyed() {
		document.removeEventListener('scroll', this.handleScroll)
	},

	methods: {
		theFormat(value) {
			if (this.impact.value.includes('$')) {
				return numeral(value).format('$0,0')
			}

			if (this.impact.value.includes('%')) {
				return numeral(value).format('0%')
			}

			if (this.$i18n.locale == 'fr') {
				return numeral(value)
					.format('0,0')
					.replace(',', ' ')
			}

			return numeral(value).format('0,0')
		},
		handleScroll() {
			const el = document.getElementById(this.impact.name)
			if (elementInViewport(el)) {
				this.$refs.number1.play()
				document.removeEventListener('scroll', this.handleScroll)
			}
		},
	},
}
</script>

<style scoped lang="scss">
li {
	@include flex-container(center, center, center);
	flex-direction: column;
	width: 20%;
	text-align: center;
	margin-bottom: 40px;

	img {
		margin-bottom: 20px;
	}

	h2 {
		position: relative;
		font-size: 50px;
		margin-bottom: 16px;
	}

	&:nth-child(2) {
		margin: 0;

		h2 {
			left: 0;
		}
	}

	p {
		@extend %nunito-bold;
		text-align: center;
		line-height: 1.5;
		width: 90%;
		margin: 0 auto;
	}

	@include mobile {
		display: block;
		margin: 0 auto 30px !important;
		padding: 0;
		width: 100%;

		.first {
			display: inline-block;
			width: 35%;
			vertical-align: top;
			margin-right: 5%;
			text-align: center;
		}

		.second {
			display: inline-block;
			width: 55%;
			position: relative;
			top: 5px;
		}

		h2 {
			font-size: 42px;
			text-align: left;
		}

		p {
			text-align: left;
			margin: 0;
		}
	}

	@include justTabletLandscape {
		img {
			max-width: 70%;
			margin: 0 auto 20px;
		}

		h2 {
			font-size: 32px;
		}
		p {
			font-size: 14px;
		}
	}
}
</style>
